<template>
	<div class="container" id="topTarget" @scroll="goscroll">
		<div class="title" style="display: flex;">
			<div>
				<!-- <span @click="go" style="margin-left: 20px;">返回</span> -->
				<!-- <el-divider direction="vertical"></el-divider> -->
			</div>
			<div style="display: flex;align-items: center;justify-content: center;flex:1;">
				{{ pageTile }}出库单
			</div>
		</div>
		
		<div style="padding: 30px;">
			<el-form v-model="storelinks">
				<div style="display: flex;">
                    <!-- <el-form-item label="开单日期:" label-width="120px" >
						<el-date-picker value-format="yyyy-MM-dd" style="width: 220px;" v-model="storelinks.sendDate" placeholder="选择开单日期:">
						</el-date-picker>
					</el-form-item> -->
                    <el-form-item label="仓库" label-width="120px">
						<el-select filterable v-model="storelinks.warehouseId" style="width: 220px" placeholder="请选择" clear 
						>
                        <!-- :remote-method="WarehouseLis" remote allow-create learable -->
							<el-option v-for="it in entrepotList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label-width="120px" label="订单类型:">
						<el-select filterable v-model="storelinks.orderType" placeholder="请选择" clear style="width: 220px"
						@change="orderTypeChange">
							<el-option v-for="it in typeList" :key="it.id" :value="it.typeKey"
								:label="it.typeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label-width="120px" label="客户:">
						<el-select filterable v-model="storelinks.customerId"  placeholder="请选择" clear 
                        @change="customerSelect"
                        style="width: 220px">
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="出库单号:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入出库单号"  v-model="storelinks.orderCode"
							auto-complete="off" disabled/>
					</el-form-item>
					
				</div>
                <div style="display: flex;">
                   
                    <el-form-item label="来源单号:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入来源单号"  v-model="storelinks.orderSource"
							auto-complete="off" />
					</el-form-item>
                    <el-form-item label="客户订单号:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入客户订单号"  v-model="storelinks.customerOrderCode"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="备注:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入备注"  v-model="storelinks.memo"
							auto-complete="off" />
					</el-form-item>   
					<el-form-item label="状态:" label-width="120px">
						<span v-if="storelinks.status==0" style="color:#409EFF;font-weight: bold;">制单中</span>
						<span v-if="storelinks.status==1" style="color:#F7BA2A;font-weight: bold;">出库中</span>
						<span v-if="storelinks.status==2" style="color:#13CE66;font-weight: bold;">已完成</span>
					</el-form-item>
                </div>
				<div style="justify-content: space-between;display: flex;align-items: center;margin-right: 20px;">
					<div style="display: flex;">
						<!-- <el-form-item label="总体积(m³):" label-width="120px">
							<el-input type="text" style="width: 220px; " placeholder="请输入总体积"  v-model="storelinks.volume"
								auto-complete="off" />
						</el-form-item>
						<el-form-item label="总重量(kg):" label-width="120px">
							<el-input type="text" style="width: 220px; " placeholder="请输入总重量"  v-model="storelinks.weight"
								auto-complete="off" />
						</el-form-item> -->
						<el-form-item label="收货地址:" label-width="120px">
							<el-input type="text" style="width: 560px; " placeholder="请输入收货地址"  v-model="storelinks.tdogAddress"
								auto-complete="off" />
						</el-form-item>
						<el-form-item label="收货单位:" label-width="120px">
							<el-input type="text" style="width: 560px; " placeholder="请输入收货单位"  v-model="storelinks.tdogGunit"
								auto-complete="off" />
						</el-form-item>
					</div>
					<div>
						<el-button type="primary" v-print="printObj" ref="printBtn" v-if="this.orderID">打印</el-button>
					</div>
				</div>
				<div style="width: 100%;position: relative;">
					<div style="justify-content: space-between;display: flex;">
						<div style="color: #606266;padding-bottom:10px;width:40%">出库商品</div>
						<div v-if="storelinks.printTimes!=0" style="padding-right:20px;width:60%;text-align: right;">
							<span>打印次数:</span>
							<span style="padding-left:5px;">{{storelinks.printTimes}}</span>
							<span>次</span>
							<span style="padding-left:20px;">打印时间:</span>	
							<span style="padding-left:5px;">{{storelinks.lastPrintDatetime}}</span>
						</div>
					</div>
					<el-form-item  >
						<div style="width: 100%;display: flex;">
							<!-- 左边 -->
							<div style="width: 35%;" >
								<el-table :data="dataList" size="mini"  height="350" 
								@row-click="handleRowClick" border
								current-row-key="index">
									<el-table-column prop="pdtCode" label="商品编号" width="180" align="center" >
										<template slot-scope="scope">
											<el-select  :remote-method="goodInput" :id="'sel'+scope.$index"  
											filterable  v-model="scope.row.pdtCode" 
											:disabled="storelinks.status==1?true:false"
											remote
												@keyup.enter.native="asd(scope.$index,$event)"
												@change="change"
												allow-create
												clearable
												placeholder="请选择" popper-class="my-select">
												<div style="display: flex;justify-content: space-between;padding: 0 20px;font-size: 14px;">
													<span>  商品名称</span>
													商品编号
												</div>
												<el-option
													@click.native="select(scope.$index,item,index)" 
													v-for="(item,index) in goodsDataList"
													:key="item.id"
													:label="item.pdtCode"
													:value="index" >
													<span style="float: left">{{ item.pdtName }}</span>
													<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pdtCode }}</span>
												</el-option>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column prop="goodsStatus" width="130" label="商品状态"  align="center">
										<template slot-scope="scope">
											<el-select filterable clearable v-model="scope.row.goodsStatus" 
											placeholder="请选择" 
											@keyup.enter.native="statusClick(scope.$index,$event)"
											:disabled="storelinks.status==1?true:false"
											@change="statusChange">
												<el-option v-for="it in stateOfGoodsList" :key="it.id" 
												:value="it.typeKey" :label="it.typeName"
												@click.native="statusSlect(scope.$index,it)" ></el-option>
											</el-select>
										</template>
									
									</el-table-column>
									<el-table-column prop="num" width="90" label="计划数"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlur(scope.$index,scope.row,'num')" 
											@input="inputInput(scope.$index,scope.row,'num')"
											@keyup.enter.native="keydown(scope.$index,scope.row,'num')"
											:disabled="storelinks.status==1?true:false"
											v-model.trim="scope.row.num" placeholder="计划数" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="eaNum" width="90" label="计划数EA"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlur(scope.$index,scope.row,'eaNum')" 
											@input="inputInput(scope.$index,scope.row,'eaNum')"
											@keyup.enter.native="keydown(scope.$index,scope.row,'eaNum')"
											:disabled="storelinks.status==1?true:false"
											v-model.trim="scope.row.eaNum" placeholder="计划数EA" clearable>
											</el-input>
										</template>
									</el-table-column>
									
									<el-table-column prop="pdtName" width="200" label="商品名称" align="center"
										class-name="small-padding ">
									</el-table-column>
									<el-table-column  width="80" label="操作" fixed="right" align="center"
										class-name="small-padding fixed-width">
										<template slot-scope="scope">
											<el-button type="text" icon="el-icon-delete"
												@click="handleDelete(scope.$index, scope.row)"></el-button>
												<el-button v-if="aid==scope.row.id"  type="text" 
													@click="tableBC(scope.$index, scope.row)">保存</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>

							<!-- 右边 -->
							<div style="width: 65%;">
								<el-table :data="rightDataList" size="mini" height="350" 
								@row-click="handleRowClickRight" class="styleTable"
								current-row-key="index">
									<el-table-column prop="pdtCode" label="商品编号" width="160" align="center" >
									</el-table-column>
									<el-table-column prop="goodsStatusName" width="70" label="商品状态"  align="center">
									</el-table-column>
									<el-table-column prop="warehouseLocationId" label="库位" align="center" 
									:show-overflow-tooltip="true" width="130">
										<template slot-scope="scope">
											<el-select filterable clearable v-model="scope.row.warehouseLocationId" 
												placeholder="请选择" 
												remote 
												@keyup.enter.native="kuweiRight(scope.$index,$event)"
												allow-create>
												<!-- @focus="locationRighAlter(scope.$index,scope.row)" -->
											<el-option v-for="(it,index) in locationRightList" :key="index" :value="it.warehouseLocationId" 
											:label="it.warehouseLocationName" @click.native="kuweiSelectRight(scope.$index,it,scope.row)" ></el-option>
											</el-select>
										</template>
									</el-table-column>
									<el-table-column prop="batchNo" width="80" label="批次"  align="center">
									</el-table-column>
									<el-table-column prop="num" width="100" label="计划数"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'num')" 
											@input="inputInputRight(scope.$index,scope.row,'num')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row, 'num')"
											v-model.trim="scope.row.num" placeholder="计划数" clearable>
											</el-input>
										</template>
									</el-table-column>
									
									<el-table-column prop="eaNum" width="100" label="计划数EA"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'eaNum')" 
											@input="inputInputRight(scope.$index,scope.row,'eaNum')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row,'eaNum')"
											v-model.trim="scope.row.eaNum" placeholder="计划数EA" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="qtyReceived" width="100" label="实出数"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'qtyReceived')" 
											@input="inputInputRight(scope.$index,scope.row,'qtyReceived')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row,'qtyReceived')"
											v-model.trim="scope.row.qtyReceived" placeholder="实出数" clearable>
											</el-input>
										</template>
									</el-table-column>
									<el-table-column prop="eaQtyReceived" width="100" label="实出数EA"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'eaQtyReceived')" 
											@input="inputInputRight(scope.$index,scope.row,'eaQtyReceived')"
											@keyup.enter.native="keydownRigt(scope.$index,scope.row,'eaQtyReceived')"
											v-model.trim="scope.row.eaQtyReceived" placeholder="实出数EA" clearable>
											</el-input>
										</template>
									</el-table-column>
									
									<el-table-column prop="remark" width="160" label="备注"  align="center">
										<template slot-scope="scope">
											<el-input  @blur="inputBlurRight(scope.$index,scope.row,'remark')" 
											@keyup.enter.native="keydownRigt(scope.$index,scope.row, 'remark')" 
											v-model.trim="scope.row.remark" placeholder="请输入备注" clearable>
											</el-input>
										</template>
									</el-table-column>
									
									
									<el-table-column  width="120" label="操作" fixed="right" align="center"
										class-name="small-padding fixed-width">
										<template slot-scope="scope">
											<el-button type="text" icon="el-icon-delete"
												@click="handleDeleteRight(scope.$index, scope.row)"></el-button>

												<el-button type="text" icon="el-icon-plus" 
												v-if="scope.$index==rightDataList.length-1" @click="addCarousel()"></el-button>

												<el-button v-if="aid==scope.row.id"  type="text" 
													@click="tableBCRight(scope.$index, scope.row)">保存</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>		
						</div>			
					</el-form-item>
				</div>
				<div style="float: right;">
					<el-button type="primary"  v-if="storelinks.status!=2" style="margin-right: 50px;"
                 	@click="submitClick">保存</el-button>
					<div style="padding-top:30px">
						<el-button type="primary" v-if="storelinks.status==0" style="margin-right: 20px;" @click="toBlockUp">出库中
							<!--  -->
						</el-button>
						<el-button type="primary" v-if="storelinks.status==1" style="margin-right: 20px;" @click="toStartUsing">关单
							 <!--  -->
						</el-button>
					</div>
					
					
					

					<!-- <el-button
						type="primary"
						icon="el-icon-printer"
						@click="printDeliver()"
						>打印
					</el-button> -->
				</div>
                <!-- @click="dialogVisible" -->
				<div style="display: flex;">
					<el-form-item label="制单人:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入制单人"  v-model="storelinks.createBy" disabled
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="仓管员:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入仓管员"  v-model="storelinks.receiver"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="装卸:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入装卸"  v-model="storelinks.stevedore"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="提货人:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入提货人"  v-model="storelinks.picker"
							auto-complete="off" />
					</el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="司机:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入司机"  v-model="storelinks.driver"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="车牌号码:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入车牌号码"  v-model="storelinks.carNo"
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="作业开始时间:" label-width="120px">
						<el-date-picker
                            v-model="storelinks.beginDatetime"
                            type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"> 
                        </el-date-picker>
					</el-form-item>
					<el-form-item label="作业结束时间:" label-width="120px">
						<el-date-picker
							v-model="storelinks.endDatetime"
							type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
				</div>
			</el-form>
		</div>


		<el-dialog :visible.sync="dialogVisibleSwiper" title="新增商品库位计划" @close="addDialogClose"
		:close-on-click-modal="false" width="70%">
			<div style="text-align: center">
				<el-form>
					<div style="display: flex;">
						<el-form-item label-width="120px"  label="商品编号">
							<!-- <el-select filterable v-model="" style="width: 200px" placeholder="请选择" clear 
							>
								<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
							</el-select> -->
							<el-select  :remote-method="goodInput"   
								filterable  v-model="popupInfo.pdtId" 
								remote
								allow-create
								clearable
								@change="poupGoodChange"
								placeholder="请选择" popper-class="my-select">
								<div style="display: flex;justify-content: space-between;padding: 0 20px;font-size: 14px;">
									<span>  商品名称</span>
									商品编号
								</div>
								<el-option
									v-for="(item,index) in goodsDataList"
									:key="index"
									:label="item.pdtCode"
									:value="item.pdtId" >
									<span style="float: left">{{ item.pdtName }}</span>
									<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pdtCode }}</span>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label-width="120px"  label="货物状态">
							<el-select filterable clearable v-model="popupInfo.goodsStatus" 
								placeholder="请选择" >
								<el-option v-for="it in stateOfGoodsList" :key="it.id" 
								:value="it.typeKey" :label="it.typeName"></el-option>
							</el-select>
						</el-form-item>
						<div style="padding-left: 80px;">
							<el-button type="primary" @click="popupSearch" >查询</el-button>
						</div>
					</div>
				</el-form>
				<div>
					<el-table :data="popupDataList" size="mini" height="350" v-loading="popupLoading" border
					@row-click="handleRowClickPopup" class="styleTable" current-row-key="index">
						<el-table-column prop="pdtCode" label="商品编号"  align="center" >
						</el-table-column>
						<el-table-column prop="pdtName" label="商品名称"  align="center" >
						</el-table-column>
						<el-table-column prop="goodsStatusName" label="商品状态"  align="center">
						</el-table-column>
						<el-table-column prop="batchNo" label="批次"  align="center">
						</el-table-column>
						<el-table-column prop="storageTime" label="入库日期"  align="center">
						</el-table-column>
						<el-table-column prop="warehouseLocationName" label="库位" align="center" >	
						</el-table-column>
						<el-table-column prop="useNum" label="库存" align="center"  >	
						</el-table-column>
						<el-table-column prop="num" label="可用数量" align="center" >	
						</el-table-column>
						<!-- <el-table-column prop="qtyReceived" label="出库数"  align="center" width="100" >
							<template slot-scope="scope">
								<el-input  @blur="inputBlurPopup(scope.$index,scope.row,'qtyReceived')" 
								@input="outNumPopup(scope.$index,scope.row)"
								@keyup.enter.native="keydownPopup(scope.$index,scope.row,'qtyReceived')"
								v-model.trim="scope.row.qtyReceived" placeholder="出库数" clearable>
								</el-input>
							</template>
						</el-table-column>
						<el-table-column prop="eaQtyReceived" label="出库数EA"  align="center" width="100">
							<template slot-scope="scope">
								<el-input  @blur="inputBlurPopup(scope.$index,scope.row,'eaQtyReceived')" 
								@keyup.enter.native="keydownPopup(scope.$index,scope.row,'eaQtyReceived')"
								v-model.trim="scope.row.eaQtyReceived" placeholder="出库数EA" clearable>
								</el-input>
							</template>
						</el-table-column> -->
						<el-table-column prop="numH" label="出库数"  align="center" width="100" >
							<template slot-scope="scope">
								<el-input  @blur="inputBlurPopup(scope.$index,scope.row,'numH')" 
								@input="outNumPopup(scope.$index,scope.row)"
								@keyup.enter.native="keydownPopup(scope.$index,scope.row,'numH')"
								v-model.trim="scope.row.numH" placeholder="出库数" clearable>
								</el-input>
							</template>
						</el-table-column>
						<el-table-column prop="eaNumH" label="出库数EA"  align="center" width="100">
							<template slot-scope="scope">
								<el-input  @blur="inputBlurPopup(scope.$index,scope.row,'eaNumH')" 
								@keyup.enter.native="keydownPopup(scope.$index,scope.row,'eaNumH')"
								v-model.trim="scope.row.eaNumH" placeholder="出库数EA" clearable>
								</el-input>
							</template>
						</el-table-column>
						<el-table-column prop="remark" width="160" label="备注"  align="center">
							<template slot-scope="scope">
								<el-input  @blur="inputBlurPopup(scope.$index,scope.row,'remark')" 
								@keyup.enter.native="keydownPopup(scope.$index,scope.row, 'remark')" 
								v-model.trim="scope.row.remark" placeholder="请输入备注" clearable>
								</el-input>
							</template>
						</el-table-column>
						<el-table-column  width="80" label="操作" fixed="right" align="center"
							class-name="small-padding fixed-width">
							<template slot-scope="scope">
								<!-- <el-button type="text" icon="el-icon-delete"
									@click="handleDeleteRight(scope.$index, scope.row)"></el-button>

									<el-button type="text" icon="el-icon-plus" 
									v-if="scope.$index==rightDataList.length-1" @click="addCarousel()"></el-button> -->

									<el-button v-if="aidPopup==scope.row.id"  type="text" 
										@click="tableBCPopup(scope.$index, scope.row)">保存</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-button @click="addDialogClose">关闭</el-button>
				<!-- <el-button type="primary" @click="popupSubmit" >提交</el-button> -->
			</div>
		</el-dialog>

		<!-- 打印    -->
		<!-- <printModal ref="printModal" style="display:none"></printModal> -->

		<div class="printBox">
			<div id="printMe" ref="printContent" class="content">
				<div style="display: flex;align-items: center;justify-content: center;">
					出库单通知单
				</div>
				<div style="height:10px;"></div>
				<el-form v-model="printInfo">
					<div style="display: flex;justify-content: space-between;height:30px;">
						
						<el-form-item  label="出库类型:" style="width: 25%;">
							<span>{{printInfo.orderTypeName}}</span>
						</el-form-item>
						<el-form-item label="来源单号:" style="width: 25%;">
							<span>{{printInfo.orderSource}}</span>
						</el-form-item>
						<el-form-item label="总体积(m³):" style="width: 25%;">
							<span>{{printInfo.volume}}</span>
						</el-form-item>
						<el-form-item label="总重量(kg):" style="width: 25%;">
							<span>{{printInfo.weight}}</span>
						</el-form-item>						
					</div>
					<div style="display: flex;justify-content: space-between;height:30px;">
						<el-form-item label="开单日期:" style="width: 25%;">
							<span>{{printInfo.createTime}}</span>
						</el-form-item>
						<el-form-item label="客户订单号:" style="width: 25%;">
							<span>{{printInfo.customerOrderCode}}</span>
						</el-form-item>
						<el-form-item label="仓库:" style="width: 25%;">
							<span>{{printInfo.warehouseName}}</span>
						</el-form-item>
						<el-form-item label="出库单号:" style="width: 25%;">
							<span>{{printInfo.orderCode}}</span>
						</el-form-item>			
					</div>
					<div style="display: flex;height:30px;">
						<el-form-item label="客户:" style="width: 30%;">
							<span>{{printInfo.customerName}}</span>
						</el-form-item>
						<el-form-item label="收货地址:" style="width: 45%;">
							<span>{{printInfo.tdogAddress}}</span>
						</el-form-item>
						<el-form-item label="收货单位:" style="width: 25%;">
							<span>{{printInfo.tdogGunit}}</span>
						</el-form-item>
					</div>
					<div style="display: flex;height:30px;justify-content: space-between;">
						<el-form-item label="备注:" >
							<span>{{printInfo.memo}}</span>
						</el-form-item>  
						<el-form-item label="打印时间:" style="text-align: right;">
							<span id="pintTimeID"></span>
							<span style="padding-left:10px;">第</span>
							<span style="padding:0 5px;" id="printNum">{{ printInfo.printTimes+1 }}</span>
							<span>次打印</span>
						</el-form-item> 
					</div>
					<!-- <div style="height:30px;">
						<el-form-item label="打印时间:" >
							<span id="pintTimeID"></span>
							<span style="padding-left:10px;">第</span>
							<span style="padding:0 5px;" id="printNum">{{ printInfo.printTimes+1 }}</span>
							<span>次打印</span>
						</el-form-item>   
					</div> -->
					
					<div style="width: auto;position: relative;">
						<table  cellspacing="0" cellpadding="0" border="1" style="background-color: #fff;">
							<thead>
								<tr>
									<td>商品编号</td>
									<td style="width:300px;">商品名称</td>
									<td>商品状态</td>
									<td>批次</td>
									<td>库位</td>
									<td style="width:60px;">计划数</td>
									<td style="width:85px;">计划数EA</td>
									<td style="width:60px;">实出</td>
									<td>备注</td>
								</tr>
							</thead>
							<tbody >
								<tr v-for="(item, index) in printDataList" :key="index" >
									<td>{{ item.pdtCode }}</td>
									<td>{{ item.pdtName }}</td>
									<td>{{ item.goodsStatusName }}</td>
									<td>{{ item.batchNo }}</td>
									<td>{{ item.warehouseLocationName }}</td>
									<td>{{ item.num }}箱</td>
									<td>{{ item.eaNum }}{{item.unitName}}</td>
									<td></td>
									<td>{{ item.remark }}</td>
								</tr>
								<tr>
									<td>数量合计</td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td>{{ printInfo.numTotal }}箱</td>
									<td>{{ printInfo.eaNumTotal }}</td>
									<td></td>
									<td></td>
								</tr>
							</tbody>
						</table>
						
					</div>
					<div class="print-footer">
						<el-form-item label="制单人:" style="width: 25%;">
							<span>{{ printInfo.createBy }}</span>
						</el-form-item>
						<el-form-item label="仓管员:" style="width: 25%;">
							<span>{{ printInfo.receiver }}</span>
						</el-form-item>
						<el-form-item label="提货人:" style="width: 25%;">
							<span>{{ printInfo.picker }}</span>
						</el-form-item>
						<el-form-item label="装卸组:" style="width: 25%;">
							<span>{{ printInfo.stevedore }}</span>
						</el-form-item>
						<el-form-item label="司机:" style="width: 25%;">
							<span>{{ printInfo.driver }}</span>
						</el-form-item>
						<el-form-item label="车牌:" style="width: 25%;">
							<span>{{ printInfo.carNo }}</span>
						</el-form-item>
						<el-form-item label="" style="width: 25%;">
							<span>第1页/共1页</span>
						</el-form-item>
					</div>
					<!-- <div style="display: flex;height:30px;">
						<el-form-item label="作业开始时间:" style="width: 50%;">
							<span>{{ storelinks.beginDatetime }}</span>
						</el-form-item>
						<el-form-item label="作业结束时间:" style="width: 50%;">
							<span>{{ storelinks.endDatetime }}</span>
						</el-form-item>
					</div> -->
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import goodsMagnifierZoom from '../../components/goods-zoom.vue';
	import printModal from '../../components/printModal.vue';
	import moment from 'moment'; 
	
	export default {
		props:['order'],
		name: "GoodsZoom",
		components: {
			goodsMagnifierZoom: goodsMagnifierZoom,
			printModal
		},
		data() {
			let that = this
			return {
				isReturn:true,
				detaillist: {},
				unitList: [],
				arsList:[],
				queryParam: '',
				isJoinCar:3,
				driverList:[],
				num: 1,
				flag:false,
				userList: [],
				storelinks: {
					status:0,
					number:0,
					billingType:1,
                    orderType: '', //typeList[0].typeKey
                    warehouseId: '', //entrepotList[0].id
                    customerId: '', //userList[0].id
					sendDate:this.Date()
				},
				orderInfo: {},
				goodsList: [],
				form: {}, 
				dataList: [
					{
                        pdtId: '',
						pdtName: '',
						remark: '',
                        unitName: '',
						pdtCode: '',
						goodsStatus: 'zp'
					}
				],
				rightDataList: [],
				formData: {},
				
				goodsDataList: [],
				contractList: [],
				typeList: [],
				ids:'',
				idStatus: '',
				aid:0,
				aidRight: 0,
				carNumberplate:'',
				routeList: [],
                isDataChangeCount:0,
                
                entrepotList: [],
                locationList: [],
                locationRightList: [],
                stateOfGoodsList: [], //货物状态
                orderID: '',
				pageTile: '',

				printInfo: {},
				printDataList: [],
				printObj : {
					id: 'printMe',//id
					popTitle: "出库通知单",//自定义设置标题
					extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
					preview: false, // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
					previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
					previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
					zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）   
					previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
					previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
					beforeOpenCallback() {}, // 开启打印前的回调事件
					openCallback() {}, // 调用打印之后的回调事件
					closeCallback() {
						that.init();
						that.getPrintInfo();
					}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
					clickMounted() { 
						// console.log('点击v-print绑定的按钮了！')
						document.getElementById('pintTimeID').innerHTML = moment().format('YYYY-MM-DD HH:mm:ss');
						that.$api.outboundDeliveryPrint({
							orderId : that.$route.query.id
						}).then(res=>{
							if(res.state = 'success'){
								let info = JSON.parse(res.data.content);
								// that.printInfo.lastPrintDatetime = info.lastPrintDatetime;
								// that.printInfo.printTimes = info.printTimes;
								// document.getElementById('pintTimeID').innerHTML = info.lastPrintDatetime;
								// document.getElementById('printNum').innerHTML = info.printTimes;
								
								// console.log('1111--', info)
								// console.log('122--', JSON.parse(res.data.content))
							}
						})
					}, //点击v-print绑定的按钮了！
					url: '',
					standard: '',
					extraCss: '',
				},

				dialogVisibleSwiper: false,
				popupInfo: {},
				popupDataList: [], //弹窗里的商品库位查询
				popupLoading: false,
				aidPopup: 0,
				poupGoodChangeBoxGauge: 0,
            }
		},
		watch: {
			carNumberplate(newValue, oldValue) {
				this.isJoinCar=this.arsList.find(item=>item.carNumberplate==newValue).isJoinCar
			},
			storelinks:{
				handler(a,b){
					if(this.$route.query.id){
						this.isDataChangeCount++
					}else{
						this.isDataChangeCount++

					}
					
				},
				deep:true
			},
			'storelinks.routeId'(a,b){
			
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
					
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
					
					}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
					
					}
					this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
				}else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
						
						}else if(this.storelinks.billingType==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
						
						}
						this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
					}
				}
			
					
				
			},
			
			'storelinks.billingType'(a,b){
				if(!this.$route.query.id){
					if(a==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						
					}else if(a==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
					}else if(a==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
					
					}
				}else{
					if(this.isDataChangeCount>1){
						if(a==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
				
						}else if(a==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
						}else if(a==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
						
						}
					}
				}
				
				
			},
			'storelinks.number'(a,b){
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
					}else if(this.storelinks.billingType==2){
					this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
					
					}
				}
				else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
						
						}
					}
				}
			},
			
		},
		
		methods: {
			addCarousel(){
				this.popupInfo = {};
				this.popupDataList = [];
				this.dialogVisibleSwiper = true;
			},
			poupGoodChange(e){
				let obj = {};
				obj = this.goodsDataList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.pdtId == e; //筛选出匹配数据
				});
				this.poupGoodChangeBoxGauge = obj.boxGauge;
				// console.log('选择的商品--', obj)
			},
			popupSearch(){ //弹窗里的搜索
				this.popupLoading = true;
				let parameter = {
					pdtId: this.popupInfo.pdtId,
					goodsStatus: this.popupInfo.goodsStatus,
					outOrderId : this.orderID,
				}
				this.$api.getLocationListRight(parameter).then((res) => {
					// console.log('2344--',res)
					if (res.state == 'success') {
						this.popupDataList = res.data
					}
					this.popupLoading = false;
				})
			},
			handleRowClickPopup(row, event, column) { //弹窗里的表格编辑
                // row 对象即为点击的行数据
                this.$nextTick(()=>{
                    this.aidPopup = row.id
                })
			},
			outNumPopup(index,b){
				// console.log('2233--', index)
				// console.log('2234--', b)
				// console.log('2235--', e)
				// this.popupDataList[index].eaQtyReceived = Number(b.qtyReceived) * Number(this.poupGoodChangeBoxGauge )
				b.eaNumH = Number(b.numH) * Number(this.poupGoodChangeBoxGauge )
			},
			inputBlurPopup(index,b,c){ //弹窗里的表格编辑
				// console.log('失焦数据--', b)
				// console.log('编辑前的数据--', b)
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.numH,
                    eaNum: b.eaNumH,
					// qtyReceived: b.numH,
					// eaQtyReceived: b.eaNumH,
					remark: b.remark,
					pdtId: b.pdtId,
					pdtCode: b.pdtCode,
					pdtName: b.pdtName,
					unitName: b.unitName,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
					volume: b.volume,
					weight: b.weight,
					warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑后的数据--', {...parameter, ...b})
				// this.$api.findcarsgood(b.pdtId).then((res) => {
				// 	res.data=JSON.parse(this.$decrypt(res.data)).data
				// 	if (res.state == 'success') {
						
				// 	}
				// })
				this.$api.addOutboundDeliveryOrderInfoRight(parameter).then(res=>{
					// res=JSON.parse(this.$decrypt(res.data))
					// console.log('失焦时间数据返回--',res);
					if(res.state=='success'){
						this.popupDataList[index] = res.data
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
				// if(c =='qtyReceived'){
				// 	// console.log('122')
				// 	this.popupDataList[index].eaQtyReceived = Number(b.qtyReceived) * Number(this.poupGoodChangeBoxGauge )
				// 	// console.log('333--', b.eaQtyReceived)
				// }
			},
			keydownPopup(index,b,c){ //弹窗里的表格编辑
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.numH,
                    eaNum: b.eaNumH,
					// qtyReceived: b.numH,
					// eaQtyReceived: b.eaNumH,
					remark: b.remark,
					pdtId: b.pdtId,
					pdtCode: b.pdtCode,
					pdtName: b.pdtName,
					unitName: b.unitName,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
					volume: b.volume,
					weight: b.weight,
					warehouseLocationId: b.warehouseLocationId
				}
				this.$api.addOutboundDeliveryOrderInfoRight(parameter).then(res=>{
					if(res.state=='success'){
						this.popupDataList[index] = res.data
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
			},
			tableBCPopup(index,b){ //弹窗里的表格的保存
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.numH,
                    eaNum: b.eaNumH,
					// qtyReceived: b.numH,
					// eaQtyReceived: b.eaNumH,
					remark: b.remark,
					pdtId: b.pdtId,
					pdtCode: b.pdtCode,
					pdtName: b.pdtName,
					unitName: b.unitName,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
					volume: b.volume,
					weight: b.weight,
					warehouseLocationId: b.warehouseLocationId
				}
				this.$api.addOutboundDeliveryOrderInfoRight(parameter).then(res=>{
					if(res.state=='success'){
						this.popupDataList[index] = res.data
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
			},
			popupSubmit(){ //弹窗里的提交
				this.$api.getOutboundDeliveryOrderInfoByID(this.orderID).then(res=>{
					this.rightDataList = res.data.listChildren;
				})
			},
			addDialogClose(){
				this.$api.getOutboundDeliveryOrderInfoByID(this.orderID).then(res=>{
					this.rightDataList = res.data.listChildren;
				})
				this.dialogVisibleSwiper = false;
			},
			getPrintInfo(){
				this.$api.getOutboundDeliveryOrderInfoByID(this.$route.query.id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					this.printInfo = res.data;
					// console.log('出库--', this.printInfo)
					this.printDataList = res.data.listChildren;
					let numTol = 0;
					let eaNumTol = 0;
					res.data.listChildren.forEach(it=>{
						numTol = numTol+it.num
						eaNumTol = eaNumTol+it.eaNum
					})
					this.printInfo.numTotal = numTol;
					this.printInfo.eaNumTotal = eaNumTol;
				})
			},
			printDeliver(data) {
				// this.$refs.printModal.handlePrint();
				// this.$api.warehouseWarrantPrint({
				// 	orderId : 38
				// }).then(res=>{
				// 	console.log('122--', JSON.parse(res.data.content))
				// 	this.printInfo = JSON.parse(res.data.content);
				// 	this.printDataList = JSON.parse(res.data.content).children;

				// })
				// this.$nextTick(()=>{
				// 	const ele = proxy.$refs.printBtn.$sel
				// 	const cli = new MouseEvent('click')
				// 	ele.dispatchEvent(cli)
				// })
				
				setTimeout(() => {
					this.$print(this.$refs.printContent);
					// this.$print(this.printObj);
				}, 1000);
				// this.$refs.printBtn.click();
			},
			orderTypeChange(e){ //订单类型选择
				let obj = {};
				obj = this.typeList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.typeKey === e; //筛选出匹配数据
				});
				// obj.prefix //前缀
				// console.log('订单类型选择---', obj)
				let serialNumber = obj.prefix;
				this.$api.getSerialNumberOut().then(res => { //出库单号序列号
					if(res.state=='success'){
						// console.log('4455--', res.message)
						serialNumber = serialNumber+res.message
						this.storelinks.orderCode = serialNumber
						// console.log('订单号---', serialNumber)
					}
				})
			},
			printClick(){
				if(this.orderID){
					this.$router.push({
						path: 'outPrint',
						query:{
							id: this.orderID, 
						}
					})
				}
				
			},
            dialogVisible(){

            },
			customerSelect(e){
                let obj = {};
				obj = this.userList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
                });
                this.storelinks.customerName = obj.customerName
            },
			Date(){
				 const now = new Date();
					const year = now.getFullYear(); // 获取当前年份
					const month = now.getMonth() + 1; // 月份从 0 开始，所以要加1
					const day = now.getDate(); // 获取当前日期
				return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
			},

			// 左边表格操作 - 开始
            handleRowClick(row, event, column) {
                // row 对象即为点击的行数据
                this.$nextTick(()=>{
                    this.aid=row.id
                })
			},
			change(e){ //选中的商品ID
				this.ids = e
			},
			asd(a,e){ //根据选中的商品ID匹配商品信息
				// console.log('9000--', this.goodsDataList[this.ids])
				this.$set(this.dataList[a],'pdtCode',this.goodsDataList[this.ids].pdtCode)
				this.$set(this.dataList[a],'unitName',this.goodsDataList[this.ids].unitName)
                this.$set(this.dataList[a],'id',this.dataList[a].id)
                this.$set(this.dataList[a],'pdtName',this.goodsDataList[this.ids].pdtName)
				this.$set(this.dataList[a],'pdtId',this.goodsDataList[this.ids].pdtId)
				this.$set(this.dataList[a],'boxGauge',this.goodsDataList[this.ids].boxGauge)
			},
			select(a,item,index) { //商品信息
				this.$set(this.dataList[a],'pdtName',item.pdtName)
				this.$set(this.dataList[a],'pdtId',item.pdtId)
				this.$set(this.dataList[a],'index',index)
				this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				this.$set(this.dataList[a],'unitName',item.unitName)
				this.$set(this.dataList[a],'boxGauge',item.boxGauge)
            },
			statusClick(){ //商品状态选择
				// console.log('000--', this.stateOfGoodsList[this.idStatus])
				this.$set(this.dataList[a],'goodsStatus',this.goodsDataList[this.idStatus].typeKey)
			},
			statusChange(e){ //选中的商品状态ID
				this.idStatus = e
			},
			statusSlect(a,item) { //商品状态
				// console.log('商品状态1---', a)
				// console.log('商品状态2---', item)
				// console.log('商品状态3---', index)
				this.$set(this.dataList[a],'goodsStatus',item.typeKey)
            },
			keydown(index,b,c){ //键盘回车事件
				if(c == 'num' || c == 'eaNum'){
					if(b.num<=0 ||b.eaNum<=0){
						this.$message.error('不可输入小于等于0的数')
						return
					}
				}
				// if(c == 'num'){
				// 	if(b.boxGauge){
				// 		b.eaNum = Number(b.num) * Number(b.boxGauge)
				// 	}
				// }
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
                    num: b.num,
                    eaNum: b.eaNum,
					goodsStatus: b.goodsStatus,
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateOutboundDeliveryOrderInfoLeft({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.dataList=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$message.success(res.message)
							this.getRightGoodStorageLocation(this.orderInfo.id)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addOutboundDeliveryOrderInfoLeft(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.dataList=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$message.success(res.message)
							this.getRightGoodStorageLocation(this.orderInfo.id)
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			tableBC(index,b){ //表格操作列保存事件
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
                    num: b.num,
                    eaNum: b.eaNum,
					goodsStatus: b.goodsStatus,
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateOutboundDeliveryOrderInfoLeft({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.dataList=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$message.success(res.message)
							// this.getRightGoodStorageLocation(this.orderInfo.id)
							this.$api.getOutboundDeliveryOrderInfoByID(this.orderInfo.id).then(res=>{
								if(res.state == 'success'){
									this.dataList = res.data.detailChildren;
									this.rightDataList = res.data.listChildren;
								}else{
									this.$message.error(res.message);
								}
								
							})
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addOutboundDeliveryOrderInfoLeft(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.dataList=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$message.success(res.message)
							this.getRightGoodStorageLocation(this.orderInfo.id) 
						}else{
							this.$message.error(res.message)
						}
					})
				}
			},
			inputInput(index,b,c){
				// console.log('..', b)
				// if(b.boxGauge){
				// 	b.eaNum = Number(b.num) * Number(b.boxGauge)
				// 	// console.log('EA数---', b.eaNum)
				// }
				if(c=='num' && b.num==0){
					this.$message.error('计划数不可以为0');
					return
				}
				if(c=='eaNum' && b.eaNum==0){
					this.$message.error('计划数EA不可以为0');
					return
				}

				if(c == 'num'){
					b.qtyReceived = b.num
					if(b.boxGauge){
						b.eaNum = Number(b.num) * Number(b.boxGauge)
						b.eaQtyReceived = b.eaNum
						// console.log('b.eaNum--', b.eaNum)
					}else{
						b.eaNum = b.eaNum
						b.eaQtyReceived = b.eaNum
					}
					return
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
					return
				}
			},
			inputBlur(index,b,c){ //表格输入框失焦事件
				if(c == 'num' || c == 'eaNum'){
					if(b.num<=0 ||b.eaNum<=0){
						this.$message.error('不可输入小于等于0的数')
						return
					}
				}
				// console.log('湘桂--', b)
				// if(c == 'num'){
				// 	// console.log('数---', b.num)
				// 	if(b.boxGauge){
				// 		b.eaNum = Number(b.num) * Number(b.boxGauge)
				// 		// console.log('EA数---', b.eaNum)
				// 	}
				// }
				let a ='sel'+(index+1)
				// console.log('dom元素--', document.getElementById(a))
				let data={
					orderId:this.orderInfo.id,
					pdtName:b.pdtName,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					unitName:b.unitName,
                    num: b.num,
                    eaNum: b.eaNum,
					goodsStatus: b.goodsStatus,
				}
				// console.log('编辑或新增的表格数据---', data)		
				if(b.id){ //编辑
					this.$api.updateOutboundDeliveryOrderInfoLeft({...data, id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦时间数据返回--',res);
						if(res.state=='success'){
							// this.dataList=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$message.success(res.message)
							this.getRightGoodStorageLocation(this.orderInfo.id)
						}else{
							this.$message.error(res.message)
						}
					})
				}else{ //新增
					// console.log(data);
					this.$api.addOutboundDeliveryOrderInfoLeft(data).then(res=>{
						// console.log('失焦时间数据返回--',res);
						// res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							// this.dataList=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							this.$message.success(res.message)
							this.getRightGoodStorageLocation(this.orderInfo.id)
							
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			},
			// 删除行
			handleDelete(index, row) {
				var _this = this
				this.$api.delOutboundDeliveryOrderInfoLeft(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						// _this.dataList.splice(index, 1)
						this.getRightGoodStorageLocation(this.orderInfo.id)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 添加行
			handleAdd() {
				var _this = this
				let list = {
					pdtId: '',
					pdtName: '',
					remark: '',
					unitName: '',
					pdtCode: '',
					goodsStatus: 'zp'
				}
				_this.dataList.push(list)
			},
			// 商品远程搜索
			goodInput(e) {
				this.goodsDataList=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
                            // console.log('下拉选择的商品信息---', item)
							this.goodsDataList.push({
								pdtName: item.pdtName,
								pdtId:item.id,
								pdtCode: item.pdtCode,
								unitName: item.unitName,
								boxGauge: item.boxGauge,
							}) 
						})
						this.flag=true
					} else {
						this.goodsDataList = []
					}


				})
			},
			// 左边表格操作 - 结束

			// 右边表格操作 - 开始
			handleRowClickRight(row, event, column) {
                // row 对象即为点击的行数据
                this.$nextTick(()=>{
                    this.aidRight=row.id
                })
			},
			kuweiRight(a,e){

			},
			kuweiSelectRight(index,it,b) {
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark
				}
				this.$api.updateOutboundDeliveryOrderInfoRight({...parameter, ...b}).then(res=>{
					// res=JSON.parse(this.$decrypt(res.data))
					// console.log('失焦时间数据返回--',res);
					if(res.state=='success'){
						this.rightDataList[index] = res.data
						// this.$nextTick(()=>{
						// 	document.getElementById(a).focus();
						// })
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
			},
			//删除行
			handleDeleteRight(index, row) {
				// console.log('删除行信息--', row)
				var _this = this
				this.$api.delOutboundDeliveryOrderInfoRight(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						_this.rightDataList.splice(index, 1)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			keydownRigt(index,b,c){ //键盘回车事件
				if(c == 'num' || c == 'eaNum'){
					if(b.num<=0 ||b.eaNum<=0){
						this.$message.error('不可输入小于等于0的数')
						return
					}
				}
				if(c == 'num'){
					b.qtyReceived = b.num
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
				}
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark
				}
				// console.log('编辑或新增的表格数据---', data)		
				this.$api.updateOutboundDeliveryOrderInfoRight({...parameter, ...b}).then(res=>{
					// res=JSON.parse(this.$decrypt(res.data))
					// console.log('失焦时间数据返回--',res);
					if(res.state=='success'){
						this.rightDataList[index] = res.data
						// this.$nextTick(()=>{
						// 	document.getElementById(a).focus();
						// })
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
				
			},
			inputInputRight(index,b,c){

				// if(c == 'num'){
				// 	b.qtyReceived = b.num
				// }
				// if(c == 'eaNum'){
				// 	b.eaQtyReceived = b.eaNum
				// }

				// console.log('箱规2--', b)
				if(c=='num' && b.num==0){
					this.$message.error('计划数不可以为0');
					return
				}
				if(c=='eaNum' && b.eaNum==0){
					this.$message.error('计划数EA不可以为0');
					return
				}

				if(c == 'num'){
					b.qtyReceived = b.num
					if(b.boxGauge){
						b.eaNum = Number(b.num) * Number(b.boxGauge)
						b.eaQtyReceived = b.eaNum
						// console.log('b.eaNum--', b.eaNum)
					}else{
						b.eaNum = b.eaNum
						b.eaQtyReceived = b.eaNum
					}
					return
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
					return
				}
			},
			inputBlurRight(index,b,c){ //表格输入框失焦事件
				// console.log('编辑---', b)
				if(c == 'num' || c == 'eaNum'){
					if(b.num<=0 ||b.eaNum<=0){
						this.$message.error('不可输入小于等于0的数')
						return
					}
				}
				if(c == 'num'){
					b.qtyReceived = b.num
				}
				if(c == 'eaNum'){
					b.eaQtyReceived = b.eaNum
				}
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId,
					remark: b.remark
				}
				this.$api.updateOutboundDeliveryOrderInfoRight({...parameter, ...b}).then(res=>{
					// res=JSON.parse(this.$decrypt(res.data))
					// console.log('失焦时间数据返回--',res);
					if(res.state=='success'){
						this.rightDataList[index] = res.data
						// this.$nextTick(()=>{
						// 	document.getElementById(a).focus();
						// })
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
				
			},
			tableBCRight(index,b){ //表格操作列保存事件
				let parameter={
					orderId:this.orderInfo.id,
                    num: b.num,
                    eaNum: b.eaNum,
					qtyReceived: b.qtyReceived,
					eaQtyReceived: b.eaQtyReceived,
					warehouseLocationId: b.warehouseLocationId
				}
				// console.log('编辑或新增的表格数据---', data)		
				this.$api.updateOutboundDeliveryOrderInfoRight({...parameter, ...b}).then(res=>{
					// res=JSON.parse(this.$decrypt(res.data))
					// console.log('失焦时间数据返回--',res);
					if(res.state=='success'){
						this.rightDataList[index] = res.data
						// this.$nextTick(()=>{
						// 	document.getElementById(a).focus();
						// })
						this.$message.success(res.message)
					}else{
						this.$message.error(res.message)
					}
				})
			},	
			// 右边表格操作 - 结束

			getRightGoodStorageLocation(id){ //查询右边商品储存库位
				this.$api.getOutboundDeliveryOrderInfoByID(id).then(res=>{
					if(res.state == 'success'){
						this.dataList = res.data.detailChildren;
						this.rightDataList = res.data.listChildren;
						this.handleAdd()
					}else{
						this.$message.error(res.message);
					}
					
				})
			},

			submitClick(){
				if (this.$vnode && this.$vnode.data.keepAlive) {
					if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance
						.cache) {
						if (this.$vnode.componentOptions) {
							var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode
								.componentOptions.tag ?
								`::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key;
							var cache = this.$vnode.parent.componentInstance.cache;
							var keys = this.$vnode.parent.componentInstance.keys;
							if (cache[key]) {
								if (keys.length) {
									var index = keys.indexOf(key);
									if (index > -1) {
										keys.splice(index, 1);
									}
								}
								delete cache[key];
							}
						}
					}
				}
                if(this.storelinks.warehouseId){}else{
                    this.$message.error('入库仓库不能为空');
                    return
                }

                if(this.storelinks.orderType){}else{
                    this.$message.error('订单类型不能为空');
                    return
                }

                if(this.storelinks.customerId){}else{
                    this.$message.error('客户不能为空');
                    return
                }

                if(this.storelinks.orderCode){}else{
                    this.$message.error('出库单号不能为空');
                    return
                }
               
                if(this.storelinks.customerOrderCode){}else{
                    this.$message.error('客户订单号不能为空');
                    return
                }
                let data={
                    // ...this.storelinks,
                    warehouseId: this.storelinks.warehouseId, //入库仓库
                    orderType: this.storelinks.orderType, //订单类型
                    orderCode: this.storelinks.orderCode, //入库单号
                    customerId: this.storelinks.customerId, //客户
                    customerName: this.storelinks.customerName, //客户名称
					orderSource: this.storelinks.orderSource, //来源单号
                    customerOrderCode: this.storelinks.customerOrderCode, //收货地址
                    tdogAddress: this.storelinks.tdogAddress, //收货单位
                    tdogGunit: this.storelinks.tdogGunit, //客户订单号
                    carNo: this.storelinks.carNo, //车牌号码
                    // volume: this.storelinks.volume, //体积
                    // weight: this.storelinks.weight, //重量
                    receiver: this.storelinks.receiver, //仓管员
					stevedore: this.storelinks.stevedore, //装卸组
					picker: this.storelinks.picker, //提货人
                    driver: this.storelinks.driver, //司机
                    memo: this.storelinks.memo, //备注
                    beginDatetime: this.storelinks.beginDatetime, //开始时间
                    endDatetime:this.storelinks.endDatetime, //结束时间
                }
                // console.log('点击提交按钮提交的数据---', data)
                // this.$encrypt(data)
                // if(this.orderID){ //编辑
					// data.id = this.orderID,
					data.id = this.orderInfo.id;
                    this.$api.updateOutboundDeliveryOrderInfo(data).then(res=>{
                        if (res.state == 'success') {
                            this.$message({
                                message: res.message,
                                type: 'success'
                            });
                            setTimeout(()=>{
								// this.$router.go(-1)
								// this.$store.commit('deletetabs', '/warehouseBill/outboundModify')
								this.$router.push({
									path: '/warehouseBill/outbound'
								})
								this.$store.commit('setactiveindex', '/warehouseBill/outbound')
                            },1000)
                            // this.isDataChangeCount--;
                        } else {
                            this.$message.error(res.message);
                        }
                    })
                // }else{
                //     this.$api.addOutboundDeliveryOrderInfo(data).then(res=>{
                //         if (res.state == 'success') {
                //             this.$message({
                //                 message: res.message,
                //                 type: 'success'
                //             });
                //             setTimeout(()=>{
                //                 this.$router.go(-1)
                //             },1000)
                //             // this.pageTile = '编辑';
                //             // this.orderID = res.data.id;
                //             // this.orderInfo = res.data;
                //             // this.storelinks = res.data;
                //             // this.isDataChangeCount = 0;
                //         } else {
                //             this.$message.error(res.message);
                //         }
                //     })
                // }
				
			},
			// 入库
			toBlockUp() {
				// console.log(e)
				if(this.$route.query.id){
					if(this.isDataChangeCount>1){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}else{
					if(this.isDataChangeCount>0){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}
				var str = "此操作将出库, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.outboundDeliveryUpdateStatus(this.orderID).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.init()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 关单
			toStartUsing() {
				// console.log(e)
				if(this.$route.query.id){
					if(this.isDataChangeCount>1){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}else{
					if(this.isDataChangeCount>0){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}
				var str = "此操作将关单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.outboundDeliveryUpdateStatus(this.orderID).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.init()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			goscroll(e) {
			},
			goBack() {
				topTarget.scrollIntoView();
			},
			go() {  
                // console.log('未知---', this.isDataChangeCount)
				if(this.storelinks.status==5){
					this.$router.go(-1)
				}else{
					if(this.$route.query.id){
						if(this.isDataChangeCount>1){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$router.go(-1)
						}
					}else{
						if(this.isDataChangeCount>0){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$router.go(-1)
						}
					}
				}
				
				
				
			},
			init(){ //编辑查询
				this.$api.getOutboundDeliveryOrderInfoByID(this.$route.query.id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					this.storelinks = res.data
					// this.formData = JSON.parse(JSON.stringify(res.data))
                    // console.log('根据ID查询--', this.storelinks)
                    // this.carNumberplate=res.data.carNumberplate
                    this.orderID = res.data.id;
					this.orderInfo = res.data;
					this.dataList = res.data.detailChildren;
					this.rightDataList = res.data.listChildren;
					
					if(this.storelinks.status==0){ //0=制单中；1=入库中，2=关单
						this.dataList.push({
							pdtId: '',
							pdtName: '',
							remark: '',
							unitName: '',
							pdtCode: '',
							goodsStatus: 'zp'
						})
					}
					
				})
			},
			save(type) {
                // console.log(`调用保存按钮方法--${type}`);
            },
			saveContent(e) {
			   var key = window.event.keyCode ? window.event.keyCode : window.event.which;
			   if (key === 83 && e.ctrlKey) {
			     this.save("hot key");
			     e.preventDefault(); //阻止浏览器默认事件
			   }
            },
            WarehouseLis(e){
                this.$api.getWarehouseListByNowUser({
                    status: 1,
                    warehouseName: e
				}).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.entrepotList = res.data
					}
				})
            },
            getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
            },
            districtFocus(e){ //库区选择 - 库位查询
                this.$api.getLocationListNoParameter({
                    warehouseLocationName: e,
                    warehouseId: this.storelinks.warehouseId,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
			districtFocusRight(){
				this.$api.getLocationListNoParameter({
                    warehouseLocationName: '',
                    warehouseId: this.storelinks.warehouseId,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						let arr =[]
						res.data.forEach((it)=>{
							arr.push({
								warehouseLocationName: it.warehouseLocationName,
								warehouseLocationId: it.id
							})
						})
						this.locationRightList = arr;
					}
				})
			},
			locationRighAlter(a, b){ //右边库位改变时
				// console.log('数据1---', a)
				// console.log('数据2---', b)
				this.$api.getLocationListRight({
					"pdtId": b.pdtId,
					"outOrderId": b.orderId,
					"goodsStatus": b.goodsStatus
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationRightList = res.data
					}
				})
			},
		},
		beforeDestroy() {
		    //销毁时移除监听
		    document.removeEventListener("keydown", this.saveContent);
		},
		mounted() {
			document.addEventListener("focus", this.saveContent);		
		},
		created() {
			if(this.$route.query.id){
                this.pageTile = '编辑';
				this.init();
				this.getPrintInfo();
			}else{
                this.pageTile = '新增';
                this.$api.addOutboundDeliveryOrderInfo().then(res=>{
					// console.log('创建---', res.data)
                    if(res.state=='success'){
                        this.orderInfo = res.data; 
                    }
                })
				this.$api.getUserInfo().then((res) => {
					// console.log(res);
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storelinks.createBy = res.data.user.name
					}
				})
			}
			// this.$api.fdriverList(this.$encrypt({})).then(res => { //司机
			// 	res.data=JSON.parse(this.$decrypt(res.data)).data
			// 	this.driverList = res.data
			// })
			// this.$api.fcarsList(this.$encrypt({})).then(res => { //车辆
			// 	res.data=JSON.parse(this.$decrypt(res.data)).data
			// 	this.arsList = res.data
			// })
			this.WarehouseLis('');
            this.getStateOfGoodsListI();
			this.districtFocus('');
			this.districtFocusRight('');

			this.$api.findPmsUnit({}).then(res => { //单位
				this.unitList = res.data.list
            })
            
			this.$api.orderlist({
				position: '出库单'
			}).then(res => {
                // console.log('入库单---', res.data)
				this.typeList = res.data
            })
            
			this.$api.findcusomer(this.$encrypt({})).then(res => { //客户
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.userList = res.data
			})
			
			// this.$api.findrouteList({}).then(res => { //路线
			// 	this.routeList = res.data
			// })

		}
	}
</script>

<style>
	/* 新建的项目  去一下默认样式 */
	body,
	html {
		padding: 0;
		margin: 0;
	}
</style>
<style leng="less" scoped>
	.styleTable{
		/* background-color: skyblue !important; */
		border-left: 1px solid #e2e2e2 !important;
	}
	.container {
		position: relative;
	}
	/* 改变下拉选项框的宽度 */
	.my-select .el-select-dropdown__item { 
		width: 800px;
	}
	.detail {
		background: rgb(244, 249, 254);
		width: 880px;
		height: 60px;
		border-radius: 5px;
		padding: 10px;
		line-height: 30px;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}

	.detaildt {
		/* width: 1380px; */
		width: 93%;
		margin: 50px;
		overflow: hidden;
		background: white;
		height: auto;
		border-radius: 10px;
	}
	/deep/ .el-select-dropdown,.el-popper{
		width: 500px;
		padding: 0 20px;
	}
	/deep/ .el-input.is-disabled .el-input__inner {
		background-color: #fdfbfb;
		border-color: #E4E7ED;
		color: #8a8a8b;
		cursor: not-allowed;
	}
	.printBox{
		display: none;
	}
</style>

<style media="print" lang="less">
	.content{
		table {
			font-family: Arial, sans-serif;
			font-size: 14px;
			background-color: #f0f2f5;
			border-collapse: collapse;
			color: #454545;
			table-layout: auto;
			width: 100%;
			text-align: center;
			border-bottom-width: 1px;
			border-bottom-style: solid;
			border-bottom-color: #dadcde;
			thead {
				border-top-width: 1px;
				border-top-style: solid;
				border-top-color: #dadcde;
				line-height: 40px;
				font-weight: bold;
				color: #454c70;
			}
			tr {
				border-top-width: 1px;
				border-top-style: solid;
				border-top-color: #dadcde;
				line-height: 23px;
			}
			td{
				padding: 5px 10px;
				font-size: 14px;
				font-family: Verdana;
				width: 100px;
				word-break: break-all; // 元素换行
			}
			// 斑马纹效果stripe
			tr:nth-child(even) {
				background: #F5F7F9;
			}
			tr:nth-child(odd) {
				background: #FFF;
			}
		}

	}
   @page {
       size:  241mm 159.5mm !important;
   	margin: 0 !important;
   }

    @media print {
        html {
            background-color: #ffffff;
            height: auto;
            margin: 0px;
            zoom: 89%;
		}
		.printBox{
			display: block;
		}
        // .content {
        //     transform: scale(0.95); /* 设置缩放比例 */
        //     transform-origin: top left; /* 确保从左上角开始缩放 */
        // }
        body {
            border: solid 1px #ffffff;
            // margin: 10mm 15mm 10mm 15mm;
            margin: 0 !important;
            padding: 0 !important;
        }
        /deep/ table {
            table-layout: auto !important;
        }
        /deep/ #pagetable table{
            table-layout: fixed !important;
        }
        .el-table__header-wrapper .el-table__header {
            width: 100% !important;
            border: solid 1px #f2f2f2;
        }
        .el-table__body-wrapper .el-table__body {
            width: 100% !important;
        }
        #pagetable table {
            table-layout: fixed !important;
		}
		.print-footer{
			position: absolute;
			bottom: 10vh;
			left: 0;
			width: 100%;
			display: flex;
		}
	}
	.client-name{
		text-align: center;
	}
</style>
